import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { CustomersListPage } from '@/features/customers';
import { workspaceSearchSchema } from '@/patterns';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/_app/customers/')({
  validateSearch: workspaceSearchSchema.extend({ nationality: zSearchText(), new: zSearchText() }),
  staticData: { crumb: 'nav.customers' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'customer.view', 'Customers'),
  component: function Customers() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <CustomersListPage
        search={search}
        onSearchChange={(patch, o) =>
          void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: o?.replace ?? false })
        }
      />
    );
  },
});
